var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.28 71.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#21222c;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.64,
    cy: 35.64,
    r: 35.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.14,35.26c.46-.68.87-1.41,1.39-2a33.24,33.24,0,0,1,11-9.19c9-4.45,17.75-3.94,26.27,1.22a35.46,35.46,0,0,1,9.81,9.14,1.9,1.9,0,0,1,0,2.47A34.43,34.43,0,0,1,47.4,47.4c-8.51,4.14-16.9,3.78-25.11-.85a35.17,35.17,0,0,1-10.7-9.69,6.13,6.13,0,0,1-.45-.84Zm14.2.37a10.3,10.3,0,1,0,10.3-10.28A10.32,10.32,0,0,0,25.34,35.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.65,41.19a5.55,5.55,0,1,1,5.53-5.55A5.57,5.57,0,0,1,35.65,41.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.cd8f8f7c1d2fd813f5c9666eee24f97e.svg";
export { ForwardRef as ReactComponent };